export default __webpack_public_path__ + "static/media/88t.cafd8d55.jpg";